import React, { createContext, useState } from 'react';

import { ContextProps, FormStepperProviderProps } from './props';

export const FormStepperContext = createContext(
  null as unknown as ContextProps
);

// consumer
export const FormStepperConsumer = FormStepperContext.Consumer;

// provider
export const FromStepperProvider: React.FC<FormStepperProviderProps> = (
  props
) => {
  const {
    onHandleNext,
    onHandleBack,
    onHandleReset,
    data,
    onHandleSaveData,
    children,
    onResetData,
  } = props;
  const [formRefCollection, setFormRefCollection] = useState<
    Record<string, any>
  >({});

  const [dataBroadcasting, setDataBroadcasting] = useState<Record<string, any>>(
    {}
  );

  const broadcastData = (name: string, data: Record<string, any>) => {
    setDataBroadcasting((prevRef) => ({
      ...prevRef,
      [name]: data,
    }));
  };

  const getBroadcastData = (name: string) => {
    return dataBroadcasting?.[name] ?? null;
  };

  const subscribeFormRef = (name: string, ref: any) => {
    setFormRefCollection((prevRef) => ({
      ...prevRef,
      [name]: ref.current,
    }));
  };

  const getFormRef = (name: string) => {
    return formRefCollection?.[name] ?? null;
  };

  return (
    <FormStepperContext.Provider
      value={{
        data,
        onHandleNext,
        onHandleBack,
        onResetData,
        onHandleReset,
        onHandleSaveData,
        subscribeFormRef,
        getFormRef,
        broadcastData,
        getBroadcastData,
      }}
    >
      {children}
    </FormStepperContext.Provider>
  );
};
